import { Check } from "lucide-react";

export const PLANS = [
  { id: "purchase", title: "Buy the module", today: 400, lines: ["$400 DS-1 module, paid today", "$49/month subscription, starts today"] },
  { id: "lease", title: "Lease purchase", today: 200, lines: ["$200 down today", "$200 balance once your system is installed and operating", "$49/month subscription, starts today"] },
];

export const PlanPicker = ({ value, onChange, accent }) => (
  <div className="grid sm:grid-cols-2 gap-3" role="radiogroup" data-testid="plan-picker">
    {PLANS.map((p) => {
      const on = value === p.id;
      return (
        <button type="button" key={p.id} role="radio" aria-checked={on} onClick={() => onChange(p.id)} data-testid={`plan-option-${p.id}`}
          className={`text-left rounded-md border p-4 transition-colors ${on ? "bg-[#141A24]" : "border-[#222D3D] bg-[#0F141C] hover:border-slate-500"}`}
          style={on ? { borderColor: accent } : undefined}>
          <div className="flex items-start justify-between gap-2">
            <p className="font-display font-semibold text-slate-100">{p.title}</p>
            {on && <Check className="h-4 w-4" style={{ color: accent }} />}
          </div>
          <p className="mt-2 font-display text-2xl text-slate-50">${p.today + 49}<span className="text-xs text-slate-500 font-sans"> due today</span></p>
          <ul className="mt-3 space-y-1 text-xs text-slate-400">
            {p.lines.map((l) => <li key={l}>· {l}</li>)}
          </ul>
        </button>
      );
    })}
  </div>
);
